import ReactGA from "react-ga4";

const appConfig = window.appconfig || {};
const { TRACKING_ID, META_PIXEL_ID } = appConfig;

let isGaInitialized = false;
let isMetaPixelInitialized = false;

// ✅ GA4 INIT
export const initializeAnalytics = () => {
  if (isGaInitialized) {
    return;
  }

  if (!TRACKING_ID) {
    console.warn("GA Tracking ID is not set.");
    return;
  }

  ReactGA.initialize(TRACKING_ID, {
    debug_mode: process.env.NODE_ENV !== "production",
  });
  isGaInitialized = true;
};

// ✅ LOG PAGE VIEW (no exclusions)
export const logPageView = (path) => {
  if (!TRACKING_ID) {
    return;
  }

  ReactGA.send({
    hitType: "pageview",
    page: path.toLowerCase(),
  });
};

// ✅ LOG EVENTS (optional, for buttons etc.)
export const logEvent = (eventName, params) => {
  if (!TRACKING_ID) {
    return;
  }

  ReactGA.event(eventName, params);
};

export const initializeMetaPixel = () => {
  if (isMetaPixelInitialized) {
    return;
  }

  if (!META_PIXEL_ID) {
    console.warn("Meta Pixel ID is not set.");
    return;
  }

  ((f, b, e, v, n, t, s) => {
    if (f.fbq) {
      return;
    }

    n = f.fbq = function () {
      if (n.callMethod) {
        n.callMethod.apply(n, arguments);
      } else {
        n.queue.push(arguments);
      }
    };

    if (!f._fbq) {
      f._fbq = n;
    }

    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

  window.fbq("init", META_PIXEL_ID);
  isMetaPixelInitialized = true;
};

export const logMetaPageView = (path) => {
  if (typeof window.fbq === "undefined") {
    return;
  }

  window.fbq("track", "PageView", {
    page_path: path.toLowerCase(),
  });
};

export const trackMetaEvent = (eventName, params = {}) => {
  if (typeof window.fbq === "undefined") {
    console.warn("Meta Pixel is not initialized or fbq is not defined.");
    return;
  }

  window.fbq("track", eventName, params);
};

// export const initializeTikTokPixel = () => {
//   if (!TIKTOK_PIXEL_ID) {
//     console.error("TikTok Pixel ID is missing!");
//     return;
//   }

//   if (typeof window.ttq === "undefined") {
//     (function (w, d, t, s, n) {
//       w[n] = w[n] || [];
//       var f = d.getElementsByTagName(t)[0],
//         j = d.createElement(t);
//       j.async = true;
//       j.src = s;
//       f.parentNode.insertBefore(j, f);
//     })(
//       window,
//       document,
//       "script",
//       "https://analytics.tiktok.com/i18n/pixel/sdk.js",
//       "ttq"
//     );

//     window.ttq = window.ttq || [];
//     window.ttq.push(["init", TIKTOK_PIXEL_ID]);
//     console.log("✅ TikTok Pixel Initialized with ID:", TIKTOK_PIXEL_ID);

//     setTimeout(() => {
//       window.ttq.push(["track", "PageView"]); // ✅ Ensure this fires after init
//       console.log("✅ TikTok PageView Event Tracked");
//     }, 2000); // ✅ Add a delay to ensure pixel loads
//   } else {
//     console.warn("TikTok Pixel is already initialized.");
//   }
// };

// ✅ TikTok Event Tracking

// ✅ Initialize TikTok Pixel
// export const initializeTikTokPixel = () => {
//   if (!TIKTOK_PIXEL_ID) {
//     console.error("❌ TikTok Pixel ID is missing!");
//     return;
//   }

//   if (typeof window.ttq !== "undefined") {
//     console.warn("⚠ TikTok Pixel is already initialized.");
//     return; // ✅ Prevents multiple initializations
//   }

//   (function (w, d, t, s, n) {
//     w[n] = w[n] || [];
//     var f = d.getElementsByTagName(t)[0],
//       j = d.createElement(t);
//     j.async = true;
//     j.src = s;
//     f.parentNode.insertBefore(j, f);
//   })(
//     window,
//     document,
//     "script",
//     "https://analytics.tiktok.com/i18n/pixel/sdk.js",
//     "ttq"
//   );

//   window.ttq = window.ttq || [];
//   window.ttq.push(["init", TIKTOK_PIXEL_ID]);
//   console.log("✅ TikTok Pixel Initialized with ID:", TIKTOK_PIXEL_ID);

//   setTimeout(() => {
//     window.ttq.push(["track", "PageView"]);
//     console.log("✅ TikTok PageView Event Tracked");
//   }, 2000);
// };

// ✅ Track Custom TikTok Events
// export const trackTikTokEvent = (eventName, params = {}) => {
//   if (typeof window.ttq !== "undefined") {
//     window.ttq.push(["track", eventName, params]);
//     console.log(`✅ TikTok Event: ${eventName}`, params);
//   } else {
//     console.warn("❌ TikTok Pixel is not initialized.");
//   }
// };
